export default function threeCardSlider() {
  const threeSlider = $('.threeCard__sliderWrapper');
  const threeSettings = {
    mobileFirst: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    cssEase: 'ease',
    easing: 'linear',
    touchMove: true,
    accessibility: true,
    autoplay: false,
    draggable: true,
    swipe: true,
    arrows: true,
    edgeFriction: 0.0005,
    touchThreshold: 20,
    prevArrow: $('.three-prev'),
    nextArrow: $('.three-next'),
    accessibility: true,
    responsive: [
      {
        breakpoint: 1020,
        settings: 'unslick',
      },
    ],
  };

  threeSlider.slick(threeSettings);

  $(window).on('resize', function () {
    if ($(window).width() > 1020) {
      return;
    }
    if (!threeSlider.hasClass('slick-initialized')) {
      return threeSlider.slick(threeSettings);
    }
  });
}
